var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-sub-title',{attrs:{"text":"Usuarios pendientes de activación"}}),_vm._v(" "),_c('app-users-pending-activation-filters',{on:{"filter":_vm.onFilter}}),_vm._v(" "),_c('app-users-pending-activation-list',{attrs:{"data":_vm.data},on:{"change-page":_vm.changePage,"sort":_vm.onSort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }